import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useDisciplineCreate } from '@/module/Discipline/model/DisciplineQuery';
import {
  DisciplineSchema,
  defaultDisciplineValues,
  disciplineSchema,
} from '@/module/Discipline/model/DisciplineSchema';

import { useAppNotification } from '@feature/utils';

import { DisciplineForm } from './DisciplineForm';

export function DisciplineCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDisciplineCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: DisciplineSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newDiscipline => {
        notification.success();
        navigate({
          to: '/administration/discipline/$disciplineId',
          params: { disciplineId: String(newDiscipline.id) },
        });
      },
    });
  };

  return (
    <DisciplineForm
      title={t('disciplines.form.title.create')}
      schema={disciplineSchema}
      defaultValues={defaultDisciplineValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
